<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label style="text-align: left;font-size: 21px;font-weight: 500;color: #278ecd;"> 1 - Date Range</label>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <label style="color: firebrick;">From Date</label>
        <input type="date" [(ngModel)]="selected_from_date" (ngModelChange)="changeEvent()" class="main-border-class">
      </div>
      <div class="col-4">
        <label style="color: firebrick;">To Date</label>
        <input type="date" [(ngModel)]="selected_to_date" (ngModelChange)="changeEvent()" [min]="selected_from_date" class="main-border-class">
      </div>
      <div class="col-3" style="padding: 8px; margin-left: 3%;">
        <mat-label style="color: firebrick;">Select Shift</mat-label>
        <mat-select [(ngModel)]="selected_session" (ngModelChange)="changeEvent()" class="main-border-class">
          <mat-option [value]="session.id" *ngFor="let session of session_list">{{session['name']}}</mat-option>
          <mat-option value="all">Morning + Evening</mat-option>
        </mat-select>
      </div>
    </div><br>
    <div class="row">
      <div class="col">
        <label style="text-align: left;font-size: 21px;font-weight: 500;color: #278ecd;"> 2 - Product</label>
      </div>
      <div class="col" style="text-align: right;">
        <button class="button-class" mat-button (click)="productClearCalled()"  style="margin-bottom: 3%;">Clear</button>
      </div>
    </div>
    <div class="row">
      <div class="col" style="border: 1px solid;overflow: auto;">
        <table style="border-collapse: collapse; border: none;">
          <tr style="background: lightgray;">
            <th>Total</th>
            <th>TM</th>
            <th>SM</th>
            <th>COW</th>
            <th>FCM</th>
            <th>TMATE</th>
            <th>Curd</th>
            <th>Butter Milk</th>
            <th>Lassi</th>
            <th></th>
            <th>SGM 450</th>
          </tr>
          <tr>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'milk_litre')"
                [checked]="checkBoxValue('milk_litre')">Total Milk Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tm_litre')" [checked]="checkBoxValue('tm_litre')">
                Total TM Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'sm_litre')" [checked]="checkBoxValue('sm_litre')">
                Total SM Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cow_litre')" [checked]="checkBoxValue('cow_litre')">
                Total COW Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'fcm_litre')" [checked]="checkBoxValue('fcm_litre')">
                Total FCM Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tea_litre')" [checked]="checkBoxValue('tea_litre')">
                Total TMATE Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'curd_kgs')" [checked]="checkBoxValue('curd_kgs')">
                Total Curd Kgs</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'buttermilk_litre')"
                [checked]="checkBoxValue('buttermilk_litre')">Total Butter Milk Litre
              </mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'lassi_litre')"
                [checked]="checkBoxValue('lassi_litre')">Total lassi Litre</mat-checkbox>
            </td>
            <td></td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'sgm450_litre')"
                [checked]="checkBoxValue('sgm450_litre')">Total SGM450 Litre</mat-checkbox>
            </td>
          </tr>
          <tr>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'milk_cost')" [checked]="checkBoxValue('milk_cost')">
                Total Milk Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tm_cost')" [checked]="checkBoxValue('tm_cost')">Total
                TM Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'sm_cost')" [checked]="checkBoxValue('sm_cost')">Total
                SM Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cow_cost')" [checked]="checkBoxValue('cow_cost')">Total
                COW Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'fcm_cost')" [checked]="checkBoxValue('fcm_cost')">
                Total FCM Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tea_cost')" [checked]="checkBoxValue('tea_cost')">
                Total TMATE Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'curd_cost')" [checked]="checkBoxValue('curd_cost')">
                Total Curd Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'buttermilk_cost')"
                [checked]="checkBoxValue('buttermilk_cost')">Total Butter Milk Cost
              </mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'lassi_cost')"
                [checked]="checkBoxValue('lassi_cost')">Total lassi Cost</mat-checkbox>
            </td>
            <td></td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'sgm450_cost')"
                [checked]="checkBoxValue('sgm450_cost')">Total SGM450 Cost</mat-checkbox>
            </td>
          </tr>
          <tr>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'fermented_products_litre')"
                [checked]="checkBoxValue('fermented_products_litre')">Total Fermented Litre
              </mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tm500_litre')"
                [checked]="checkBoxValue('tm500_litre')">TM 500 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'std500_litre')"
                [checked]="checkBoxValue('std500_litre')">SM 500 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cow500_litre')"
                [checked]="checkBoxValue('cow500_litre')">COW 500 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'fcm1000_litre')"
                [checked]="checkBoxValue('fcm1000_litre')">FCM 1000 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tea1000_litre')"
                [checked]="checkBoxValue('tea1000_litre')">TMATE 1000 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'curd500_kgs')"
                [checked]="checkBoxValue('curd500_kgs')">Curd 500 Kgs</mat-checkbox>
            </td>
          </tr>
          <tr>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'fermented_products_cost')"
                [checked]="checkBoxValue('fermented_products_cost')">Total Fermented Cost
              </mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tm500_cost')"
                [checked]="checkBoxValue('tm500_cost')">TM 500 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'std500_cost')"
                [checked]="checkBoxValue('std500_cost')">SM 500 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cow500_cost')"
                [checked]="checkBoxValue('cow500_cost')">COW 500 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'fcm1000_cost')"
                [checked]="checkBoxValue('fcm1000_cost')">FCM 1000 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tea1000_cost')"
                [checked]="checkBoxValue('tea1000_cost')">TMATE 1000 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'curd500_cost')"
                [checked]="checkBoxValue('curd500_cost')">Curd 500 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'set1000_kgs')"
                [checked]="checkBoxValue('set1000_kgs')">SETCURD 1000 kgs</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'set1000_cost')"
                [checked]="checkBoxValue('set1000_cost')">SETCURD 1000 cost</mat-checkbox>
            </td>
          </tr>
          <tr>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'total_litre')"
                [checked]="checkBoxValue('total_litre')">Total Litre</mat-checkbox>
            </td>
            <td>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'std250_litre')"
                [checked]="checkBoxValue('std250_litre')">SM 250 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cow250_litre')"
                [checked]="checkBoxValue('cow250_litre')">COW 250 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cow200_litre')"
                [checked]="checkBoxValue('cow200_litre')">COW 200 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'fcm500_litre')"
                [checked]="checkBoxValue('fcm500_litre')">FCM 500 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tea500_litre')"
                [checked]="checkBoxValue('tea500_litre')">TMATE 500 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'curd150_kgs')"
                [checked]="checkBoxValue('curd150_kgs')">Curd 150 Kgs</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'set500_kgs')"
                [checked]="checkBoxValue('set500_kgs')">SETCURD 500 kgs</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'set500_cost')"
                [checked]="checkBoxValue('set500_cost')">SETCURD 500 cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'sgm450_cost')"
                [checked]="checkBoxValue('sgm450_cost')">SGM450 cost</mat-checkbox>
            </td>
           
          </tr>
          <tr>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'total_cost')"
                [checked]="checkBoxValue('total_cost')">Total Cost</mat-checkbox>
            </td>
            <td>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'std250_cost')"
                [checked]="checkBoxValue('std250_cost')">SM 250 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cow250_cost')"
                [checked]="checkBoxValue('cow250_cost')">COW 250 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cow200_cost')"
                [checked]="checkBoxValue('cow200_cost')">COW 200 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'fcm500_cost')"
                [checked]="checkBoxValue('fcm500_cost')">FCM 500 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tea500_cost')"
                [checked]="checkBoxValue('tea500_cost')">TMATE 500 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'curd150_cost')"
                [checked]="checkBoxValue('curd150_cost')">Curd 150 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'curd5000_kgs')"
                [checked]="checkBoxValue('curd5000_kgs')">Curd 5000 kgs</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'curd5000_cost')"
                [checked]="checkBoxValue('curd5000_cost')">Curd 5000 cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'sgm450_litre')"
                [checked]="checkBoxValue('sgm450_litre')">SGM450 Litre</mat-checkbox>
            </td>

          </tr>
          <!-- <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            
          </tr> -->
        </table>
      </div>
    </div><br>
    <div class="row">
      <div class="col">
        <label style="text-align: left;font-size: 21px;font-weight: 500;color: #278ecd;"> 3 - Booths To Include</label>&nbsp;&nbsp;<span style="color: #aea9a9;">Enter
          comma
          seperated values</span>
      </div>
      <div class="col" style="text-align: right;">
        <label style="margin-right: 9%;font-size: 17px; color: firebrick;">{{booth_code_list.length}} Booths</label>
        <button class="button-class" mat-button (click)="boothclearCalled()" style="margin-bottom: 3%;">Clear</button>
      </div>
    </div>
    <div class="row">
      <div class="col" style="border: 1px solid; padding: 10px; overflow: auto; height: 200px;">
        <mat-chip-list #chipList>
          <mat-chip *ngFor="let booth of booth_code_list" [selectable]="selectable" [removable]="removable"
            (removed)="removeBoothCalled(booth)">
            {{booth}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <input #fruitInput [(ngModel)]="entered_booth_code" [matChipInputFor]="chipList" (ngModelChange)="changeEvent()" 
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addNewBoothCalled()">
        </mat-chip-list>
      </div>
    </div><br>
    <!-- <hr style="background: lightgray;"> -->
    <div class="row" *ngIf="general_report_data !== null">
      <div class="col-4" style="height: 500px;border: 1px solid;overflow: auto; text-align: center;">
        <label style="text-align: center; font-size: 22px; color: firebrick;">Zone</label>
        <hr style="background: lightgray;">
        <mat-list role="list">
          <mat-list-item>
            <mat-checkbox (change)="selectAllZonedCalled($event)" [checked]="is_all_zone_selected">Select All
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item *ngFor="let zone of zone_list">
            <mat-checkbox (change)="zoneValueChanged($event, zone['id'])" [checked]="zoneCheckBoxValue(zone['id'])">
              {{zone['name']}}</mat-checkbox>
          </mat-list-item>
        </mat-list>
      </div>
      <div class="col-4" style="height: 500px;border: 1px solid;overflow: auto; text-align: center;">
        <label style="text-align: center; font-size: 22px; color: firebrick;">Booth Type</label>
        <hr style="background: lightgray;">
        <mat-list role="list">
          <mat-list-item *ngFor="let business_type of business_type_list">
            <mat-checkbox (change)="businessTypeValueChanged($event, business_type['id'])"
              [checked]="businessTypeCheckBoxValue(business_type['id'])">{{business_type['name']}}</mat-checkbox>
          </mat-list-item>
        </mat-list>
      </div>
    </div><br>
    <div class="row">
      <div class="col">
        <label style="text-align: left;font-size: 21px;font-weight: 500;color: #278ecd;"> 3 - Booths To Exclude</label>&nbsp;&nbsp;<span style="color: #aea9a9;">Enter
          comma
          seperated values</span>
      </div>
      <div class="col" style="text-align: right;">
        <label style="margin-right: 9%;font-size: 17px; color: firebrick;">{{exclude_booth_code_list.length}}
          Booths</label>
        <button class="button-class" mat-button (click)="boothclearCalledForExclude()"
          style="margin-bottom: 3%;">Clear</button>
      </div>
    </div>
    <div class="row">
      <div class="col" style="border: 1px solid; padding: 10px; overflow: auto; height: 200px;">
        <mat-chip-list #chipList>
          <mat-chip *ngFor="let booth of exclude_booth_code_list" [selectable]="selectable" [removable]="removable"
            (removed)="removeBoothCalledForExclude(booth)">
            {{booth}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <input #fruitInput [(ngModel)]="entered_booth_code_for_exclude" [matChipInputFor]="chipList" 
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addNewBoothCalledForExclude()">
        </mat-chip-list>
      </div>
    </div><br>

    <div class="row">
      <div class="col" *ngIf="!is_document_available">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="50">
        </mat-progress-spinner>
      </div>
      <div class="col" style="text-align: center;">
        <button mat-button class="button-class" [disabled]="checkDisabled()" (click)="getClicked()">Get</button>
      </div>
      <div class="col-4" *ngIf="document_file!== null && is_document_available">
        <button mat-button class="button-class" (click)="downloadClicked()"><i class="material-icons">
            get_app
          </i> Download Excel</button>
      </div>
    </div><br><br><br>
  </div>
</section>